import type { ConditionalFormattingModification } from "../store/schema/ConditionalFormattingRule";
import type { ConditionalFormattingScenario } from "../store/schema/ConditionalFormattingScenarioType";
import { getConditionalFormattingStore } from "../store/store";
import type { MailboxInfo } from "owa-client-types";

export default function getConditionalFormattingModificationForRow(key: string, mailboxInfo: MailboxInfo, scenario: ConditionalFormattingScenario): ConditionalFormattingModification[] {
    const rowToModifications = getConditionalFormattingStore(mailboxInfo, scenario).rowToModificationsMap;
    return rowToModifications.get(key) ?? [];
}
